import { newColors } from "constants/newColors";
import React from "react";
import styled from "styled-components";

export type StyledTableCellProps = {
  width?: React.CSSProperties["width"];
  minWidth?: React.CSSProperties["minWidth"];
  textAlign?: React.CSSProperties["textAlign"];
};

export type TableColumnProps = {
  columnId: string;
  columnType: string;
  textAlign: React.CSSProperties["textAlign"];
  minWidth: React.CSSProperties["minWidth"];
  text: string;
  width: React.CSSProperties["width"];
};

export const StyledTable = styled.table`
  width: 100%;
  height: 100%;
`;

export const StyledThead = styled.thead`
  display: block;
  width: 100%;
  height: 50px;
`;

export const StyledTheadTr = styled.tr`
  width: 100%;
`;

export const StyledTheadTh = styled.th<StyledTableCellProps>`
  padding: 1rem 0.5rem;
  width: ${({ width }) => width};
  min-width: ${({ minWidth }) => minWidth};
  text-align: ${({ textAlign }) => textAlign || "left"};
`;

export const StyledRightestTheadTh = styled.th<StyledTableCellProps>`
  padding: 1rem 23px 1rem 0.5rem;
  width: ${({ width }) => width};
  min-width: ${({ minWidth }) => minWidth};
  text-align: ${({ textAlign }) => textAlign || "left"};
`;

export const StyledTbody = styled.tbody`
  display: block;
  width: 100%;
  height: calc(100% - 50px);
  overflow-y: scroll;
  background: ${newColors.white};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
`;

export const StyledTbodyTr = styled.tr`
  width: 100%;
  border-bottom: solid 1px ${newColors.border};
  transition-duration: 0.15s;

  :hover {
    background: ${newColors.hover};
    cursor: pointer;
  }
`;

export const StyledNoHoverTbodyTr = styled.tr`
  width: 100%;
  border-bottom: solid 1px ${newColors.border};
`;

export const StyledTbodyTd = styled.td<StyledTableCellProps>`
  vertical-align: middle;
  padding: 1rem 0.5rem;
  vertical-align: middle;
  width: ${({ width }) => width};
  min-width: ${({ minWidth }) => minWidth};
  text-align: ${({ textAlign }) => textAlign || "left"};
`;

export const StyledTableCell = styled.div<StyledTableCellProps>`
  width: ${({ width }) => width};
  min-width: ${({ minWidth }) => minWidth};
  margin: 0 1rem;
  box-sizing: border-box;
`;
